<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>{{ label }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="addChild" :disabled="!canCreate">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list>
            <v-list-item v-for="empleo in empleos" :key="empleo.orden">
              <app-empleo-completo
                :value="empleo"
                :empleos="empleos"
                ref="hijos"
              ></app-empleo-completo>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";

import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    loading: false,
    empleos: [],
  }),
  props: {
    value: {
      type: Object,
      required: false,
    },
    propName: {
      type: String,
      required: false,
      default: "empleos",
    },
    label: {
      type: String,
      default: "Actividades",
    },
    iconName: {
      type: String,
      default: "phone",
    },
  },
  watch: {
    "value.empleos": function (item) {
      this.empleos = item;
      this.setEmpleos();
    },
  },
  computed: {
    ...mapGetters(["checkCanUpdate"]),
    canCreate: function () {
      return this.checkCanUpdate("ap-puede-modificar-empleadores");
    },
  },
  created() {
    // cargo el modelo
    this.setEmpleos();
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    setEmpleos() {
      if (!this.value[this.propName]) {
        // Si el empleo no está cargado, creo la propiedad
        this.empleos = [];

        this.value[this.propName] = this.empleos;
      }
      this.empleos = this.value[this.propName];
    },
    async addChild() {
      var laActividadEs = "Principal";
      if (this.empleos.length == 1) laActividadEs = "Secundaria";
      if (this.empleos.length == 2) laActividadEs = "Terciaria";

      const res = await this.$dialog.confirm({
        text: "¿Está seguro que quiere agregar una actividad ?",
        title: "Agregar Actividad " + laActividadEs,
        persistent: true, // Parece que no funciona...
      });

      if (!res) {
        return;
      }

      var ultimoOrden = 0; // Busco el último orden que hay
      for (let index = 0; index < this.empleos.length; index++) {
        ultimoOrden = this.empleos[index].orden;
      }

      var nuevoEmpleo = this.getEmpleoVacio().then((nuevoEmpleo) => {
        nuevoEmpleo.orden = this.empleos.length + 1;
        this.empleos.push(nuevoEmpleo);
        Vue.nextTick(() => {
          // esto es para esperar a que se renderice el componente nuevo
          this.$refs.hijos.find(
            (ref) => ref.empleo.orden == nuevoEmpleo.orden
          ).editModeOn = true;
        });
      });
    },
    async getEmpleoVacio() {
      this.loading = true;

      try {
        var result = await http.get(
          "personas/personaempleo/00000000-0000-0000-0000-000000000000"
        );

        return result;
      } catch (error) {
        // Error
        this.alertError(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteChild(empleoAEliminar) {
      const res = await this.$dialog.confirm({
        text: "¿Confirma la eliminación del Empleo?",
        title: "Confirmar Operación",
        persistent: true, // Parece que no funciona...
      });

      if (res) {
        var indiceAEliminar = -1;
        for (let index = 0; index < this.empleos.length; index++) {
          if (this.empleos[index].orden == empleoAEliminar.orden) {
            indiceAEliminar = index;
            break;
          }
        }

        //Vue.$log.debug(indiceAEliminar);

        if (indiceAEliminar >= 0) {
          this.empleos.splice(indiceAEliminar, 1);
        }
      }
    },
  },
};
</script>

<style></style>
